import { Component, Input } from '@angular/core'
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service'

import { OperadoraDeMaquina } from '../../pkw-data/collect/operadora-de-maquina.model'

@Component({
    selector: 'col-operadoras-homologadas-modal',
    templateUrl: './operadoras-homologadas-modal.component.html',
    styleUrls: ['./operadoras-homologadas-modal.component.scss']
})
export class OperadorasHomologadasModalComponent {
    @Input() operadoras: OperadoraDeMaquina[]

    constructor(private bsModalRef: BsModalRef) {}

    fechar() {
        this.bsModalRef.hide()
    }
}



// WEBPACK FOOTER //
// ./src/app/estabelecimentos/operadoras-homologadas-modal/operadoras-homologadas-modal.component.ts